import React from 'react';
import ReactLoading from 'react-loading';

const Loading = ({ type, color, failed = false }) => {
    if (type === undefined)
        type = 'bubbles';
    
    if (failed)
        type = 'blank';
    
    return <>
        <div className='d-flex justify-content-center align-items-center'>
            <ReactLoading type={type} color='#0f3e85' width={'10%'} className='align-items-center'/>
                {failed && <h3>Loading Failed</h3>}
        </div>
        </>
};

export default Loading;